'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.ipCountryQuery = void 0;
var tslib_1 = require("tslib");
var magic_messages_1 = require("@gig/magic-messages");
function ipCountryQuery() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, window.queryBus.query(magic_messages_1.IP_COUNTRY_QUERY)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.ipCountryQuery = ipCountryQuery;
